export const en = {
    'yandex': 'Yandex',
    'last-streams': 'Past khurals',
    'text-stream': 'Stream text translation',
};
